import {
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogSub,
  DialogSubContent,
  DialogSubTrigger,
} from '@src/design-system/dialog';
import { Button } from '@src/design-system/button';
import { EditMessageIcon } from '@shared/assets/icons/shared/edit-message-icon';

import { CreateNoteSubModal } from '../sub-modals/create-note-sub-modal';
import { AppointmentNoteCard } from '../appointment-note-card';

import type { TAppointment } from '@shared/types/appointment';
import { HasPermission } from '@features/roles/guards/has-permission';
import { entities } from '@shared/constants/entities';
import Loader from '@shared/components/reusables/loader';
import meetingNoteApi from '@features/participants/services/meeting-note-api';

export function AppointmentNotesModal({ id }: { id: TAppointment['id'] }) {
  const { data: meetingNotesData, isLoading } = meetingNoteApi.useFetch({
    meeting: id,
  });

  const meetingNotes = meetingNotesData?.results;

  return (
    <>
      <DialogHeader>Meeting Notes</DialogHeader>
      <DialogBody>
        {isLoading ? (
          <Loader height={400} />
        ) : (
          <div className='flex flex-col gap-4 pb-2'>
            {!meetingNotes?.length ? (
              <span className='w-full pt-24 flex justify-center items-center'>
                No notes for this appointment
              </span>
            ) : (
              meetingNotes?.map((note) => (
                <AppointmentNoteCard
                  key={note.id}
                  {...note}
                />
              ))
            )}
          </div>
        )}
      </DialogBody>
      <HasPermission
        entity={entities.meetingNote}
        action='add'
      >
        <DialogSub>
          <DialogSubTrigger>
            <DialogFooter>
              <Button className='flex-1 hover:bg-primary-100 border text-gray-800 border-primary-200 bg-primary-50'>
                <EditMessageIcon />
                Write note
              </Button>
            </DialogFooter>
          </DialogSubTrigger>

          <DialogSubContent>
            <CreateNoteSubModal meetingId={id} />
          </DialogSubContent>
        </DialogSub>
      </HasPermission>
    </>
  );
}
